import { ReactNode } from "react";
import { CandidateHeader } from "./Header";
import { CandidateSidebar } from "./Sidebar";
import { cn } from "@/lib/utils";
import { SupportAgentChat } from "@/components/support/SupportAgentChat";
import { useSupportAgentVisibility } from "@/hooks/useSupportAgent";
import { IncompleteProfileBanner } from "@/components/auth/IncompleteProfileBanner";

interface CandidateLayoutProps {
  children: ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl" | "full";
  className?: string;
}

const maxWidthClasses = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  "7xl": "max-w-7xl",
  full: "max-w-full",
};

export function CandidateLayout({ 
  children, 
  maxWidth = "5xl",
  className 
}: CandidateLayoutProps) {
  const { showAgent } = useSupportAgentVisibility();

  return (
    <div className="min-h-screen bg-background">
      <CandidateHeader />
      <div className="flex w-full">
        {/* Sidebar - hidden on mobile via CSS, fixed on desktop */}
        <div className="hidden md:block">
          <CandidateSidebar />
        </div>
        
        {/* Main content - full width on mobile, with margin on desktop for fixed sidebar */}
        <main className="flex-1 py-6 px-3 sm:px-4 md:py-8 md:px-8 md:ml-64 min-w-0 w-full overflow-x-hidden">
          <div className={cn(maxWidthClasses[maxWidth], "mx-auto w-full min-w-0", className)}>
            <IncompleteProfileBanner />
            {children}
          </div>
        </main>
      </div>
      {showAgent && <SupportAgentChat />}
    </div>
  );
}
